// extracted by mini-css-extract-plugin
module.exports = {"instructionsMsg":"SearchGroupsList_instructionsMsg__2wv14","container":"SearchGroupsList_container__26wpF"};